import policyAdvisorIcon from './assets/icons/Engine_artwork_EducationEngine_BLACK.png'
import commsProfessional from './assets/icons/Engine_artwork_WebEngine_BLACK.png'
import schoolImprovementPlanIcon from './assets/icons/Engine_artwork_DataEngine_BLACK.png'
import bidWriterIcon from './assets/icons/Engine_artwork_Privacy_BLACK.png'
import sendPlannerIcon from './assets/icons/Engine_artwork_KnowledgeEngine_BLACK.png'
import reportWriterIcon from './assets/icons/Engine_artwork_ProposalEngine_BLACK.png'
import inspectionToolKitIcon from './assets/icons/Engine_artwork_InstantEngine_BLACK.png'
import dataAnalysisIcon from './assets/icons/Engine_artwork_APIENgine_BLACK.png'

type ImageImports = {
    [key: string]: string;
  };

  const imageImports: ImageImports = {
    policyAdvisorIcon: policyAdvisorIcon,
    commsProfessional: commsProfessional,
    schoolImprovementPlanIcon: schoolImprovementPlanIcon,
    bidWriterIcon: bidWriterIcon,
    sendPlannerIcon: sendPlannerIcon,
    reportWriterIcon: reportWriterIcon,
    inspectionToolKitIcon: inspectionToolKitIcon,
    dataAnalysisIcon: dataAnalysisIcon
  };

export default imageImports;
